export default __webpack_public_path__ + "static/r360-large-24164755e8177689ef1d1465347c90a7.png";